function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#C66E4E;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M358.8,39.4h-16.9l-21.8,70.6h19l5.5-19.4h15.6l4.1,19.4h11.8L358.8,39.4z M353.4,59.1l4.6,21.5h-10.6 L353.4,59.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M579.9,39.4H563l-21.6,70.1l-0.2,0.5h19l5.5-19.4h15.6l4.1,19.4h11.8L579.9,39.4z M574.6,59.1l4.6,21.5h-10.7 L574.6,59.1z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "258.7,38.1 257.5,49.6 272.7,49.6 265.8,110.1 281.9,110.1 288.8,49.6 304.1,49.6 305.4,38.1 "
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M152.6,46.2c-3.9-4.6-9.5-7.4-15.6-7.8c-12-1-22.7,7-23.9,17.8l-3.5,33.4V90l0,0c-0.3,10.3,8.4,19.1,19.9,20 c0.7,0.1,1.4,0.1,2,0.1c10.7,0,19.9-7,21.7-16.5h0.1l3.6-33.8C157.3,54.8,155.8,50,152.6,46.2z M139.6,51.6l-4.7,45.7 c-0.2,1.8-2.2,3.2-4.5,3c-1.2-0.1-2.3-0.6-3.1-1.5c-0.5-0.6-0.8-1.4-0.7-2.1l4.7-45.7c0.2-1.7,2-3,4.1-3h0.4 c1.2,0.1,2.3,0.6,3.1,1.5C139.4,50.1,139.7,50.8,139.6,51.6L139.6,51.6z"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "508.3,38.3 500.1,109.4 500.1,109.8 516.8,109.8 524.9,38.8 525,38.3 "
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "467.7,39.4 453.4,90.4 442.5,39.4 430.7,39.4 448.1,110.1 464.9,110.1 486.5,39.9 486.7,39.4 "
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M82.6,46.1c-4.5-5.2-11.3-8-19.2-8H46.7L38.9,110h16l2.3-20.8c17.5,0,29.1-11.4,30.6-25.5 C88.5,57.4,86.6,51,82.6,46.1z M61.8,46.2H67c1.1,0,2.2,0.4,2.9,1.3c0.6,0.7,0.9,1.7,0.8,2.6L68.2,75c-0.3,2.3-2.3,4-4.6,4h-5.2 L61.8,46.2z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M228.6,63.7c0.8-6.3-1.1-12.7-5.2-17.6c-4.5-5.2-11.3-8-19.2-8h-16.7l-7.8,71.8h16l2.3-20.8l11.2,20.8h13.2 l-11.8-23C220.5,83.3,227.5,74.3,228.6,63.7z M211.5,50.1L209,75c-0.3,2.3-2.3,4-4.6,4h-5.2l3.5-32.8h5.1c1.1,0,2.2,0.4,2.9,1.3 C211.3,48.2,211.6,49.1,211.5,50.1z"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 636.2 146.6",
    style: {
      enableBackground: "new 0 0 636.2 146.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.68efda12.svg";
export { ForwardRef as ReactComponent };